// 工单's counts for the menu: the tickets support has answered since the
// customer last opened them. Read when the console starts and every minute
// after, and again by the ticket pages as soon as they have changed one.
import { ref } from 'vue'
import { api, type TicketSummary } from '@/api/client'

export const ticketSummary = ref<TicketSummary | null>(null)

let timer: ReturnType<typeof setInterval> | undefined

export async function refreshTickets() {
  try {
    ticketSummary.value = await api.ticketSummary()
  } catch {
    // The count stays as it was; the pages say what failed.
  }
}

/** Starts the minute's refresh, once. */
export function watchTickets() {
  if (timer) return
  void refreshTickets()
  timer = setInterval(() => void refreshTickets(), 60_000)
}
